const { hostname } = document.location;
const match = hostname.match(/(liepin|lebanban|duomian|wisest).([0-9a-z]+)$/) || [];
const [, domain = 'liepin', suffix = 'com'] = match;

let reuqestProtocol = 'https';

if (domain === 'tongdao') {
  reuqestProtocol = 'http';
}

export default () => {
  return `${reuqestProtocol}://touchway.${domain}.${suffix}`;
};